import React from 'react';
import AccountCard from './AccountCard';
import VideoEditorPicker from '../VideoEditorPicker';
import type {VideoEditor} from '../../backend-types/user';

interface VideoEditorCardProps {
  videoEditor: VideoEditor | null;
  onSelect: (editor: VideoEditor) => void;
  onClear: () => void;
  isSaving: boolean;
}

/**
 * Settings' half of the video editor question — see `useVideoEditorPreference` for the logic this
 * wraps, and `welcome/WelcomeGuide.tsx` for the onboarding half asking the same question.
 */
const VideoEditorCard: React.FC<VideoEditorCardProps> = ({
  videoEditor,
  onSelect,
  onClear,
  isSaving,
}) => (
  <AccountCard
    title="Video editor"
    description="Which app you import our XML into — it tailors what the convert dialog tells you
     about linking your source audio after import."
  >
    <div className="mt-4">
      <VideoEditorPicker
        value={videoEditor}
        onSelect={onSelect}
        onClear={onClear}
        disabled={isSaving}
      />
    </div>
  </AccountCard>
);

export default VideoEditorCard;
